// Turns the StockMultiSelect selection into ?securities=type:id,... for the server's TransactionFilter.
// The Laji filter (related_model_type / second_type) is left alone: the options were already narrowed
// by it, so the two agree. Selecting every option is the same as "Kaikki" and sends nothing, which
// also keeps the URL short when someone picks a long list.
export const withSecurityFilter = (params, allSecurities) => {
  const { selected_securities, stock, ...rest } = params
  const selected = selected_securities || []

  if (selected.length === 0 || (allSecurities?.length > 0 && selected.length >= allSecurities.length)) {
    return rest
  }

  return {
    ...rest,
    securities: selected.map(obj => `${obj.related_model_type}:${obj.related_model_id}`).join(","),
  }
}
